export const BASE = 0
export const ABOVE = 1
export const NAVBAR = 30
export const BOTTOM_SHEET = 40
export const MODAL = 50
export const DATEPICKER = MODAL + ABOVE
export const GLOBAL_LOADING = 100
